import React from 'react';
import { theme } from 'antd';

export const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => {
  const { token } = theme.useToken();
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ color: token.colorTextSecondary, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1.2, marginBottom: 4 }}>
        {label}
      </div>
      <div style={{ color: token.colorText, fontSize: 14 }}>{children}</div>
    </div>
  );
};
